import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-image-select-item-bar" }
const _hoisted_2 = { class: "pantry-image-select-item-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "pantry-image-select-item",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickRoom()))
  }, [
    _withDirectives(_createVNode("div", _hoisted_1, null, 512), [
      [_vShow, _ctx.isActive()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
      [_vShow, !_ctx.isActive()]
    ]),
    _createVNode("div", {
      class: "pantry-image-select-item-text",
      style: {fontWeight: _ctx.styleText()}
    }, _toDisplayString(_ctx.getTitle()), 5)
  ]))
}